import { Node } from 'tiptap';
import { InputRule } from 'prosemirror-inputrules';
import { Transaction } from 'prosemirror-state';
import MergeTagView from '@/editor/tiptap/nodes/MergeTagView.vue';
import { ProsemirrorHelper } from '@/editor/helpers/prosemirror.helper';
import { IField, IMergeValues } from '@/editor/types';

export default class MergeTagNode extends Node {
  constructor(
    options = {
      onOpenMenu: () => undefined,
      mergeValues: {} as IMergeValues,
      fields: [] as IField[],
      isTemplate: false,
    }
  ) {
    super(options);
  }

  get name() {
    return 'merge_tag';
  }

  get schema() {
    return {
      attrs: {
        tagId: {
          default: '',
        },
        category: {
          default: '',
        },
        mergeKey: {
          default: '',
        },
      },
      group: 'inline',
      inline: true,
      selectable: true,
      draggable: false,
      parseDOM: [
        {
          tag: 'span.merge-tag',
          getAttrs: dom => ({
            tagId: dom.getAttribute('tagId'),
            category: dom.getAttribute('category'),
            mergeKey: dom.getAttribute('mergeKey'),
          }),
        },
      ],
      toDOM: node => ['span', { ...node.attrs, class: 'merge-tag' }],
    };
  }

  inputRules({ type }) {
    const inputRule = new InputRule(/{{/, ({ tr }, match, start, end) => {
      let transaction: Transaction = tr;
      if (match[0]) {
        transaction.replaceWith(start, end, type.create());
        transaction = ProsemirrorHelper.selectNode(tr, start);
      }

      return transaction;
    });
    return [inputRule];
  }

  // Override default behavior and let all events through
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  stopEvent() {}

  get view() {
    return MergeTagView;
  }
}
